// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3DX7p","calendarButtons":"ClockData_calendarButtons__1L5JQ"};